import { keyBy } from 'lodash';
import { createSelector } from 'reselect';

export const getPeople = state => state.search.people;
export const getCompanies = state => state.search.companies;


export const getPeopleById = createSelector(
  [getPeople],
  people => keyBy(people, person => person.id)
);

export const getCompaniesById = createSelector(
  [getCompanies],
  companies => keyBy(companies, company => company.id)
);
